import { Textarea } from 'ui'
import { ControlledField } from './ControlledField'
import { SigningFormFieldProps } from './Switcher'

export const TextareaField = (props: SigningFormFieldProps) => {
  return (
    <ControlledField {...props}>
      {({ field }) => (
        <Textarea
          {...field}
          id={props.field.id}
          style={{
            fontSize: 'inherit',
          }}
          onBlur={() => props.onPersist(field.value)}
          className='bg-white rounded-none focus-visible:ring-black min-h-full resize-none p-0 w-full h-full'
          placeholder={props.field.label}
        />
      )}
    </ControlledField>
  )
}
